import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie'

import Modal from '../Modal'
import Text from '../Text'

import { loadingTexts } from '../../constants/common'
import * as atomicLoaderAnimationData from '../../assets/animations/atomic-loader.json'

const AtomicLoader = ({ show = false }) => {
  const [text, setText] = useState('Uploading...')

  const atomicLoaderAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: atomicLoaderAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    if (show) {
      setText(loadingTexts[Math.floor(Math.random() * loadingTexts.length)])
    }
  }, [show])

  if (!show) return null

  return (
    <Modal
      isOpen={show}
      onClose={() => {}}
      fullScreen={true}
      showCloseBtn={false}
    >
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="mb-10">
          <Lottie
            options={atomicLoaderAnimationOptions}
            height={180}
            width={180}
          />
        </div>
        <Text
          variant="body"
          size="medium"
          tag="p"
          bold={'true'}
          className="text-gray-600 px-10 text-center"
        >
          {text}
        </Text>
      </div>
    </Modal>
  )
}

export default AtomicLoader
